import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import { fetchCustomArticleLifeTime } from '@hub/bearing-hub/libs/BearingsLifetime/fetchCustomArticleLifeTime';
import type {
  IbhCatalogArticleLifetimeParams,
  IbhCustomArticleLifetimeParams,
  IbhIcnArticleLifetimeParams,
} from '@igus/iglidur-bearing-hub-api';
import { IbhProductionMethods } from '@igus/iglidur-bearing-hub-api';
import { fetchIcnArticleLifeTime } from '@hub/bearing-hub/libs/BearingsLifetime/fetchIcnArticleLifeTime';
import { fetchCatalogArticleLifeTime } from './fetchCatalogArticleLifeTime';

type ArticleLifetimeParams =
  IbhCatalogArticleLifetimeParams | IbhCustomArticleLifetimeParams | IbhIcnArticleLifetimeParams;

export const useArticleLifeTime = (
  enabled: boolean,
  articleLifetimeParams: ArticleLifetimeParams,
  shouldRecalculateLifeTime: boolean,
  productionMethod?: IbhProductionMethods
) => {
  const queryKey = ['articleLifetime', productionMethod, shouldRecalculateLifeTime];

  const fetchArticleLifeTime = () => {
    if (productionMethod === IbhProductionMethods.SEMIFINISHED) {
      return fetchIcnArticleLifeTime(articleLifetimeParams as IbhIcnArticleLifetimeParams);
    }
    if ('shape' in articleLifetimeParams) {
      return fetchCustomArticleLifeTime(articleLifetimeParams as IbhCustomArticleLifetimeParams);
    }
    return fetchCatalogArticleLifeTime(articleLifetimeParams);
  };

  const {
    data: lifetime,
    isFetching,
    isLoading,
    status,
    refetch,
  } = useQuery({
    queryKey,
    queryFn: fetchArticleLifeTime,
    enabled,
    gcTime: 0,
  }) as UseQueryResult<number>;

  return { lifetime, isFetching, isLoading, status, recalculateLifeTime: refetch };
};
